export default __webpack_public_path__ + "static/media/warningDotIcon.60748efe.svg";